module.exports = __webpack_public_path__ + "static/fiji3-768x638-fd0936c94776e1f91987a42fa64f629e.png";